(function(){
  function init(root){
    if(root.dataset.panGalleryInitialized==='true')return;
    root.dataset.panGalleryInitialized='true';
    const slides=[...root.querySelectorAll('[data-pan-slide]')];
    if(slides.length<2)return;
    let current=0,timer=null;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const auto=!reduced&&root.dataset.editor!=='true';
    const interval=Math.max(4000,Math.min(10000,Number(root.dataset.interval)||6000));
    function stop(){if(timer!==null){window.clearInterval(timer);timer=null;}}
    function start(){stop();if(auto&&!document.hidden)timer=window.setInterval(()=>select(current+1),interval);}
    function select(index){current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==current;slide.inert=i!==current;});}
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else start();});
    document.addEventListener('shopify:block:select',event=>{const block=slides.find(s=>s.dataset.blockId===event.detail.blockId);if(block){stop();select(slides.indexOf(block));}});
    start();
  }
  function boot(){document.querySelectorAll('[data-pan-gallery]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
